import React from 'react'

interface Props {
    textos: string[]
}

export const H2Generator: React.FC<Props> = ({ textos }) => {
    return (
        <React.Fragment>
            {
                textos.map((texto, key) => (
                    <h2 key={key}>{texto}</h2>
                ))
            }
        </React.Fragment>
    )
}